module.exports = __webpack_public_path__ + "static/media/Janalogo.81be476b.jpg";